import { defineStore } from 'pinia'
import { computed } from 'vue'
import { http } from '@/services/http.service'
import { useDataStore } from '@/stores/data.store'

export const RADII = [0, 0.25, 0.5, 0.75, 1]

export const useConfigStore = defineStore('config', {
  persist: true,
  state: () => ({
    baseColor: 'neutral',
    radius: 0.5, // Valor por defecto
  }),
  actions: {
    hydrateTheme(color: string | null, newRadius: number | string | null) {
      if (color)
        this.baseColor = color
      if (newRadius !== null)
        this.radius = Number(newRadius)
      this.applyThemeToHtml()
    },
    async setBaseColor(color: string, toast: (options: { title: string, description: string }) => void) {
      this.baseColor = color
      await this.updateTheme(toast)
    },
    async setRadius(newRadius: number, toast: (options: { title: string, description: string }) => void) {
      this.radius = newRadius
      await this.updateTheme(toast)
    },
    async updateTheme(toast: (options: { title: string, description: string }) => void) {
      this.applyThemeToHtml()
      const companyStore = useDataStore()
      const companyId = computed(() => companyStore.company)

      if (companyId.value != null) {
        try {
          await http.patch(`/companies/${companyId.value}`, {
            company: {
              theme_color: this.baseColor,
              theme_radius: this.radius,
            },
          })
          toast({
            title: 'Tema actualizado',
            description: `Se ha cambiado el tema.`,
          })
        }
        catch (error) {
          console.error(error)
          toast({
            title: 'Error al cambiar el tema',
            description: 'Por favor, inténtalo de nuevo más tarde.',
          })
        }
      }
    },
    applyThemeToHtml() {
      const htmlElement = document.documentElement
      // Limpiar clases de tema anteriores
      htmlElement.classList.forEach((className) => {
        if (className.startsWith('theme-')) {
          htmlElement.classList.remove(className)
        }
      })

      // Añadir clase de tema base
      htmlElement.classList.add(`theme-${this.baseColor}`)

      // Aplicar el radio
      htmlElement.style.setProperty('--radius', `${this.radius}rem`)
    },
  },
})
